import axiosInstance from '../../utils/axiosConfig';
import { getClaimDetails } from "./claim";
import { getPolicyDetails, getGoodDetails } from "./policy";
import { getPersonDetails } from "./party";
import {getServiceProposalById} from "./claimManagement"
export const CREATE_MISSION_EXPERT = "CREATE_MISSION_EXPERT";


function formatIsoDate(isoDate) {
  const date = new Date(isoDate);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}
const getAdresse = (partyAddresses) => {  
    const address = partyAddresses[0]?.address?.number+" "+ partyAddresses[0]?.address?.street+" "+partyAddresses[0]?.address?.state?.label+" "+partyAddresses[0]?.address?.postalCode?.postalCode
    if(address.includes("undefined")){
      return "N/A"
    }else {
      return address || {}
    }
  }
const getTypeMission= (id) => {
  switch(id){
    case '1':
      return "Première Expertise"
    case '2':
      return "Deuxième Expertise"
    case '3':
      return "Contre-Expertise"
    case '4':
      return "Arbitrage"
    case '5':
      return "Arbitrage Client MAE"
    case '6':
      return "Rapport De Carrence"
    case '7':
      return "Expertise Judiciare"
    default:
      return "N/A"}

}

const getCoverageLabels= (affectedCoverages) => {
  if (Array.isArray(affectedCoverages)) {
     
      return affectedCoverages.map(coverage => coverage.coverage.label).join(' , ');
  }
  return '';  
}
  export const createMissionExpert = (claim ,task ,inspectorWorkspaceId , location) => async (dispatch) => {
    try {
       
      
        console.log("test 1 ")
        let dateExpertise = ""
         
        if ('_proposedServiceId' in task.variables) {
          console.log(`test value ${task.variables._proposedServiceId?.value}`);
        
          // Await the result of getServiceProposalById
          try {
            let proposedService = await getServiceProposalById(task.variables._proposedServiceId?.value);

            if (proposedService && proposedService.clientDecision === "ACCEPTANCE") {
                dateExpertise = formatIsoDate(proposedService.estimatedCarDeposalDate);
            }
           
            
            console.log("dateExpertise :" ,dateExpertise)

            // Now you can use proposedService
          } catch (error) {
            console.error(`Error getting ServiceProposal ById: ${error.message}`);
          }
        }
      
      console.log("test 2 ")
        
        // const policyUidAdverse = claim.involvedPolicies.find(policy => policy.role === "AdversePolicy").policyUid;
        const policyUidInsured = claim.involvedPolicies.find(policy => policy.role === "InsuredPolicy").policyUid;
        console.log("test 3 ")
        const policeInsured = await getPolicyDetails(policyUidInsured);
        console.log("test 4 ")
        // const policeAdverse = await getPolicyDetails(policyUidAdverse); 
         
        // const carAdverse = claim.involvedCars.find(cars => cars.role === "ADVERSE_CAR").goodUid;
        // const goodAdverse = await  getGoodDetails(carAdverse);
        const carInsured = claim.involvedCars.find(cars => cars.role === "INSURED_CAR").goodUid;
        console.log("test 5 ")
        const goodInsured = await  getGoodDetails(carInsured);
        console.log("test 6 ")
        // const partiesAdverse = claim.involvedParties.find(partie => partie.role === "AdverseDriver").partyUid;
        // const partiesInsured = claim.involvedParties.find(partie => partie.role === "InsuredDriver").partyUid;

        // const personDetailsAdverse = await getPersonDetails(policeAdverse?.policyHolder);
         
         let typeMission  = getTypeMission(task?.variables?.idMissionType?.value)
        const personDetailsInsured = await  getPersonDetails(policeInsured?.policyHolder);
        console.log("test 7 ")
  
        let missionExpert = {}
        missionExpert.dateEnvoiMission = formatIsoDate(new Date());
        missionExpert.mission= {
        "dateEnvoiMission":  formatIsoDate(new Date()),
        "type": typeMission ,  
        "examinationLocation": location,
        "dateExpertise":dateExpertise,
        "etat":"AWAITING_INSPECTION"
        };
        console.log("missionExpert.mission : ",missionExpert.mission)
        missionExpert.inspectorWorkspaceId =inspectorWorkspaceId  ;
        console.log("missionExpert.inspectorWorkspaceId : ",missionExpert.inspectorWorkspaceId) 
        missionExpert.claim = {
            "claimNumber": claim.claimNumber,
            "type": "Assurance",
            "kind": task?.variables?.managementType?.value,
            "claimDate":formatIsoDate(claim.occurrenceDate ),
            "reportingNumber":  claim?.additionalData?.reportingNumber, 
            "typeOfClaim": claim?.additionalData?.typeOfClaim || "",
            "coverages":getCoverageLabels(claim?.affectedCoverages) || "",
                };
        console.log("missionExpert.claim : ",missionExpert.claim)
        missionExpert.car= {
            "category": "Vehicule simple", //goodInsured?.type
            "licencePlateNumber": goodInsured.goodCaracteristique.find(good => good.key === "License_plate")?.value || 'N/A',
            "model" :goodInsured.goodCaracteristique.find(good => good.key === "Model")?.value || 'N/A',
            "vv" :goodInsured.goodCaracteristique.find(good => good.key === "Market_value")?.value || 'N/A',
            "vn" :goodInsured.goodCaracteristique.find(good => good.key === "New_value")?.value || 'N/A',
            "manufacturer" :goodInsured.goodCaracteristique.find(good => good.key === "Brand")?.value || 'N/A',
            "power" :goodInsured.goodCaracteristique.find(good => good.key === "Power")?.value || 'N/A',
            "firstCirculationDate" :goodInsured.goodCaracteristique.find(good => good.key === "Registration_date")?.value || 'N/A',
                };
        console.log("missionExpert.car : ",missionExpert.car)
        missionExpert.insurance= { 
            "name": policeInsured.insuranceCompany.label || "S.T.A.R", 
                };
        missionExpert.report = {
          "vehiculeState":claim.vehiculeState || 'N/A',
          "accordPris":"Assure",
          "vehiculeExpertise" :"Assure"
        }
        console.log("missionExpert.insurance : ",missionExpert.insurance)
        missionExpert.agency= { 
            "_id": claim.reportingAgency._id } ;
                console.log("missionExpert.agency : ", missionExpert.agency)
        missionExpert.police={
            "name": personDetailsInsured?.name+" "+personDetailsInsured?.lastName,
            "contrat": policeInsured?.policyNumber,
            "address":  getAdresse(personDetailsInsured?.partyAddresses),
            "identityNumber" : policeInsured?.identityNumber
                };
                console.log(" missionExpert.police : ", missionExpert.police)
        missionExpert.tiers={
            "name":  "Adverse  For Test",
            "doss": "00000000",
            "contrat": " ",
            "type": "Assurance",
            "address": "tunis",
            "category": "Vehicule simple", //goodInsured?.type 
            "immatriculation": " " ,
            "insuranceCompany": {
                "name":   "S.T.A.R"  },
            "agency": {
                "name":  claim.reportingAgency._id}
                };
                console.log("missionExpert.tiers : ",missionExpert.tiers)
        console.log("missionExpert : ",missionExpert)
     const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_EXPERT_MISSION}/missions/creatMission`, missionExpert);
     return response.data
    } catch (error) {
      dispatch({
        type: 'CREATE_MISSION_EXPERT',
        payload: error.response? error.response.data : 'Server error',
      });
    }
  };


  export const createExpert = (expertStarEx) => async (dispatch) => {
    try {
     const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_EXPERT_MISSION}/expert/addExpert`, expertStarEx);
     return response.data
    } catch (error) {
      dispatch({
        type: 'CREATE_EXPERT',
        payload: error.response? error.response.data : 'Server error',
      });
    }
  };

  export const updateExpert = (expertWorkspaceId ,expertStarEx) => async (dispatch) => {
    try {
     const response = await axiosInstance.put(`${process.env.REACT_APP_BACKEND_URL_EXPERT_MISSION}/expert/updateExpert/${expertWorkspaceId}`, expertStarEx);
     return response.data
    } catch (error) {
      dispatch({
        type: 'UPDATE_EXPERT',
        payload: error.response? error.response.data : 'Server error',
      });
    }
  };

 


  export async function addPaymentMissionExpert(requestData) {
    try {
      const idHonoraireExpert = requestData.additionalData?.idHonoraireExpert
         
      const url = `${process.env.REACT_APP_BACKEND_URL_EXPERT_MISSION}/payments/${idHonoraireExpert}`;
      const today = new Date();
      const response = await axiosInstance.post(url , {
        "index": 2,
        "type": "Especes",
        "date": today.toISOString().split('T')[0],
        "number": "",
        "banque": "",
        "amount": requestData.inspectionAmount,
        "rs": 0,
        "cgc": 0
    }); 
      return response.data;
    } catch (error) {
      console.error(`Error Add Payment Mission Expert call: ${error.message}`);
    }
  }
